import { useState } from 'react'

interface Performance {
  date: string,
  location: string,
  description: string,
  tags: {
    isFestival: boolean,
    isTour: boolean
  }
};

const performances: Performance[] = [
  { date: '08/26-09/26', location: 'East Coast & Midwest US', description: 'Headlining Tour', tags: { isFestival: false, isTour: true } },
  { date: '08/26', location: 'Charlotte, NC', description: 'Carolina Bloom Festival with Quarters, Oceanic', tags: { isFestival: true, isTour: false } },
  { date: '04/26', location: 'Gainesville, FL', description: 'Big Culture and Arts Festival with Earl Sweatshirt, The Alchemist', tags: { isFestival: true, isTour: false } },
  { date: '05/26', location: 'Tampa, FL', description: 'Sold out 2 nights Crowbar headliner', tags: { isFestival: false, isTour: false }},
  { date: '04/26', location: 'Tampa, FL', description: 'Gasparilla Music Festival with Mt. Joy', tags: { isFestival: true, isTour: false } },
  { date: '03/26', location: 'Florida', description: 'Tour with Congress', tags: { isFestival: false, isTour: true } },
  { date: '11/25', location: 'Western US', description: 'Don\'t Come Down Tour Part II (Headliner)', tags: { isFestival: false, isTour: true } },
  { date: '10/25', location: 'Florida', description: 'Tour with Magic City Hippies', tags: { isFestival: false, isTour: true } },
  { date: '08/25-09/25', location: 'East Coast US', description: 'Don\'t Come Down Tour (Headliner)', tags: { isFestival: false, isTour: true } },
  { date: '08/25', location: 'Tampa, FL', description: 'Sold out Crowbar Album Release Headliner', tags: { isFestival: false, isTour: false } },
  { date: '08/25', location: 'Atlanta, GA', description: 'Sold out with Hallpass at Vinyl Center Stage', tags: { isFestival: false, isTour: false } },
  { date: '07/25', location: 'Nashville, TN', description: 'At Basement East supporting Pretty Jane', tags: { isFestival: false, isTour: false } },
  { date: '05/25', location: 'St. Petersburg, FL', description: 'Sold out Bayboro Brewing headliner', tags: { isFestival: false, isTour: false } },
  { date: '05/25', location: 'Orlando, FL', description: 'Sold out with Good Neighbours at Will\'s Pub', tags: { isFestival: false, isTour: false } },
  { date: '04/25', location: 'St. Augustine, FL', description: 'Sold out Indie night at Cafe Eleven', tags: { isFestival: false, isTour: false } },
  { date: '03/25', location: 'Florida', description: 'Tour with The Stews', tags: { isFestival: false, isTour: true } },
  { date: '02/25', location: 'Florida', description: 'Tour with Ax & the Hatchetmen', tags: { isFestival: false, isTour: true } },
  { date: '12/24', location: 'Tampa, FL', description: 'Sold out Crowbar headliner', tags: { isFestival: false, isTour: false } },
  { date: '09/24', location: 'Gainesville, FL', description: 'Sold out Indie night at The Wooly​', tags: { isFestival: false, isTour: false } },
  { date: '07/24', location: 'Florida', description: 'Tour with The Moss and Dogpark', tags: { isFestival: false, isTour: true } },
  { date: '06/24', location: 'St. Petersburg, FL', description: 'Sold out Indie night with Mustard Service at Floridian Social', tags: { isFestival: false, isTour: false } },
  { date: '05/24', location: 'Orlando, FL', description: 'Indie night with Mustard Service at The Beacham', tags: { isFestival: false, isTour: false } },
  { date: '05/24', location: 'Miami, FL', description: 'Sold out indie night at Gramps', tags: { isFestival: false, isTour: false } },
  { date: '12/23', location: 'Tampa, FL', description: ' 97X Next Big Thing Festival with The Black Keys, Bleachers, Misterwives, and more', tags: { isFestival: true, isTour: false } },
  { date: '11/23', location: 'Tampa, FL', description: 'Sold out headliner at Crowbar', tags: { isFestival: false, isTour: false } },
  { date: '9/23', location: 'Jacksonville, FL', description: 'Taco and Tequila Fest with Lupe Fiasco, Iration, and more', tags: { isFestival: true, isTour: false } },
  { date: '07/23-08/23', location: 'East Coast US', description: 'The Daybreak Tour Part II (Headliner)', tags: { isFestival: false, isTour: true } },
  { date: '07/23', location: 'Orlando, FL', description: 'Sold out with Flipturn at House of Blues', tags: { isFestival: false, isTour: false } },
  { date: '03/23', location: 'S. Florida', description: 'Okeechobee Fest with Odesza, Turnstile, Hippo Campus, Inner Wave, Flipturn, Local Natives', tags: { isFestival: true, isTour: false } },
  { date: '11/22-12/22', location: 'East Coast US', description: 'The Daybreak Tour Part I (Headliner)', tags: { isFestival: false, isTour: true } },
  { date: '08/22', location: 'Florida', description: 'Tour with Hotel Fiction', tags: { isFestival: false, isTour: true } },
  { date: '08/22', location: 'Gainesville, FL', description: 'Playground Fest with Flipturn, Lunar Vacation, and more', tags: { isFestival: true, isTour: false } },
  { date: '07/22', location: 'Tampa, FL', description: 'Sold out with Flipturn at Crowbar', tags: { isFestival: false, isTour: false } },
  { date: '04/22', location: 'Orlando, FL', description: 'Sold out with Palace at The Social', tags: { isFestival: false, isTour: false } },
  { date: '02/22', location: 'Tampa, FL', description: 'Gasparilla Music Festival with Black Pumas, The Aces, Grouplove, and more', tags: { isFestival: true, isTour: false } },
  { date: '10/21', location: 'Tampa, FL', description: 'The Hails and The Polar Boys at Crowbar', tags: { isFestival: false, isTour: false } },
  { date: '02/20', location: 'Orlando, FL', description: 'Have Mercy, Fredo Disco, Selfish Things, Young Culture at Soundbar', tags: { isFestival: false, isTour: false } },
  { date: '01/20', location: 'East Coast US', description: 'The Beautiful Ordinary Tour (Headliner)', tags: { isFestival: false, isTour: true } },
]

function filterByTour(performance: Performance) {
  if (performance.tags.isTour) return true;
};

function filterByFestival (performance: Performance) {
  if (performance.tags.isFestival) return true;
};

export default function Performances() {
  const [filter, setFilter] = useState('all'); // 'all', 'festivals', 'tours'
  let displayPeformances;
  if (filter === 'tours') {
    displayPeformances = performances.filter(filterByTour);
  } else if (filter === 'festivals') {
    displayPeformances = performances.filter(filterByFestival);
  } else {
    displayPeformances = performances;
  }


  return (
    <>
      <p className="sr-only" aria-live="polite" aria-atomic="true">
        {displayPeformances.length} {filter === 'all' ? '' : filter} performance{displayPeformances.length !== 1 ? 's' : ''} shown
      </p>
      <div role="group" aria-label="Filter performances" className="flex justify-center xl:justify-start gap-4 pb-4">
        <button
          aria-pressed={filter === 'tours'}
          className={`${filter === 'tours' ? 'border-transparent bg-orange text-white' : ' border-black bg-white'} text-black text-center font-semibold text-lg w-36 md:w-48 px-2 py-1 md:py-2 md:text-2xl border-2 rounded-2xl hover:bg-orange`}
          onClick={() => setFilter(filter === 'tours' ? 'all' : 'tours')}
        >
          Tours
        </button>
        <button
          aria-pressed={filter === 'festivals'}
          className={`${filter === 'festivals' ? 'border-transparent bg-orange text-white' : ' border-black bg-white'} text-black text-center font-semibold text-lg w-36 md:w-48 px-2 py-1 md:py-2 md:text-2xl border-2 rounded-2xl hover:bg-orange`}
          onClick={() => setFilter(filter === 'festivals' ? 'all' : 'festivals')}
        >
          Festivals
        </button>
      </div>
      <div role="table" id="performancesTable" className="w-full py-2 md:py-4 text-black text-xs sm:text-sm grid grid-cols-8 lg:grid-cols-7 gap-4 md:gap-1 items-start">
        <div role="rowgroup" className="contents">
          <div role="row" className="contents">
            <div role="columnheader" className="justify-self-start pb-2 text-left font-bold text-base sm:text-lg col-span-1">Date</div>
            <div role="columnheader" className="justify-self-start pb-2 text-left font-bold text-base sm:text-lg col-span-2 lg:col-span-1">Location</div>
            <div role="columnheader" className="justify-self-end pb-2 text-right font-bold text-base sm:text-lg xl:justify-self-start xl:text-left col-span-5 lg:col-span-5">Description</div>
          </div>
        </div>
        <div role="rowgroup" className="contents">
          {displayPeformances.map((performance, index) => (
            <div key={index} role="row" className="contents">
              <div role="cell" className="justify-self-start text-left font-bold col-span-1">{performance.date}</div>
              <div role="cell" className="justify-self-start text-left font-normal italic col-span-2 lg:col-span-1">{performance.location}</div>
              <div role="cell" className="justify-self-end text-right xl:justify-self-start xl:text-left font-normal col-span-5 lg:col-span-5">{performance.description}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
};